
import React, { useEffect, useRef } from 'react';

const AnimatedBackground = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const iconsList = [
      'fas fa-microchip', 'fas fa-laptop-code', 'fas fa-mobile-alt',
      'fas fa-syringe', 'fas fa-heartbeat', 'fas fa-hospital-user',
      'fas fa-tower-broadcast', 'fas fa-recycle', 'fas fa-leaf',
      'fas fa-trash-alt', 'fas fa-battery-full', 'fas fa-plug'
    ];

    for (let i = 0; i < 30; i++) {
      const iconName = iconsList[Math.floor(Math.random() * iconsList.length)];
      const iconElem = document.createElement('i');
      iconElem.className = `icon-object ${iconName}`;
      iconElem.style.fontSize = `${Math.random() * 2 + 0.8}rem`;
      iconElem.style.left = `${Math.random() * 100}%`;
      iconElem.style.top = `${Math.random() * 100}%`;
      iconElem.style.animationDuration = `${Math.random() * 30 + 25}s`;
      iconElem.style.animationDelay = `${Math.random() * 15}s`;
      iconElem.style.opacity = `${Math.random() * 0.08 + 0.02}`;
      iconElem.style.color = '#53b096';
      container.appendChild(iconElem);
    }

    return () => {
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    };
  }, []);

  return (
    <div className="animated-bg">
      <div className="bg-gradient-layer"></div>
      <div className="floating-icons" ref={containerRef}></div>
      <style>{`
        .animated-bg {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: -2;
          overflow: hidden;
          background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 50%, #f0f4f8 100%);
        }
        .bg-gradient-layer {
          position: absolute;
          width: 100%;
          height: 100%;
          background: radial-gradient(circle at 20% 50%, rgba(83,176,150,0.08) 0%, rgba(255,255,255,0) 70%);
          pointer-events: none;
        }
        .floating-icons {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          pointer-events: none;
        }
        .icon-object {
          position: absolute;
          font-size: 1.8rem;
          opacity: 0.4;
          filter: drop-shadow(0 0 2px rgba(83,176,150,0.1));
          animation: gentleFloat 40s linear infinite;
        }
        @keyframes gentleFloat {
          0% { transform: translateY(100vh) translateX(0) rotate(0deg); opacity: 0; }
          10% { opacity: 0.06; }
          90% { opacity: 0.08; }
          100% { transform: translateY(-20vh) translateX(40px) rotate(15deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default AnimatedBackground;